import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Form.css';
import { requiredFieldClass, requiredFileWrapClass } from '../lib/requiredFieldClass';

const DRAFT_KEY = 'draft_mynumber';

const MyNumberForm = ({ onBack, onNext, isFirstForm, isLastForm, isMultiForm, id, isDraft }) => {
    const [formData, setFormData] = useState({
        myNumber: '',
        image: '',
        //memberId: ''
    });
    const [imageFile, setImageFile] = useState(null); 
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const me = await api.get('/api/me/');
                if (me?.data?.memberId) {
                    setFormData(prev => ({ ...prev, memberId: me.data.memberId }));
                } else {
                    alert('エラー: 社員番号が取得できませんでした。');
                    navigate('/m/login');
                }
            } catch (e) {
                alert('エラー: 認証が切れています。');
                navigate('/m/login');
            }
        })();
    }, [navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'myNumber') {
            const digitsOnly = value.replace(/\D/g, '').slice(0, 12);
            setFormData(prev => ({ ...prev, myNumber: digitsOnly }));
            return;
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleSaveDraft = () => {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ myNumber: formData.myNumber }));
        alert('一時保存しました。（画像は保存されません）');
    };

    const handleDeleteDraft = async () => {
        const confirmDelete = window.confirm("この下書き（一時保存データ）を削除してもよろしいですか？\n※削除すると元に戻せません。");
        if (!confirmDelete) return;

        setLoading(true);
        try {
            if (id) {
                await api.delete(`/api/applications/drafts/${id}/`);
            }
            // ローカルでも削除
            localStorage.removeItem(DRAFT_KEY);
            alert('下書きを削除しました。');
            navigate('/applications');
        } catch (error) {
            console.error('下書きの削除に失敗:', error);
            alert('下書きの削除に失敗しました。もう一度お試しください。');
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => { if (onBack) onBack(); else navigate('/applications'); };

    useEffect(() => {
        try {
            const saved = localStorage.getItem(DRAFT_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                setFormData(prev => ({ ...prev, myNumber: parsed.myNumber || '' }));
            }
        } catch (_) {}
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!imageFile) {
            alert("マイナンバーカードの画像をアップロードしてください。");
            return;
        }

        const isConfirmed = window.confirm("マイナンバー情報を提出してもよろしいですか？");
        if (!isConfirmed) return;

        const data = new FormData();
        //data.append('memberId', formData.memberId);
        data.append('myNumber', formData.myNumber);
        data.append('image', imageFile); 

        //const data = {
        //    myNumber: formData.myNumber,
        //    image: formData.imageFile
        //};
        try {
            
            await api.post('/api/forms/submit_mynumber/', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            
            //await api.post('/api/forms/submit_mynumber/', data);
            localStorage.removeItem(DRAFT_KEY);
            alert('マイナンバー情報が正常に提出されました。');
            navigate('/applications');
        } catch (error) {
            console.error('Submission failed:', error);
            alert('申請に失敗しました。');
        }
    };

    return (
        <div className="container form-container">
            <h3>マイナンバー登録申請 </h3>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">個人番号</label>
                    <input 
                        type="text" 
                        name="myNumber" 
                        className={requiredFieldClass(formData.myNumber)}
                        value={formData.myNumber} 
                        onChange={handleInputChange} 
                        maxLength="12"
                        inputMode="numeric"
                        pattern="\d{12}"
                        placeholder="123456789012（数字12桁）"
                        required 
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">本人確認書類（画像）</label>
                    <div className={requiredFileWrapClass(imageFile)}>
                        <input 
                            type="file" 
                            className="form-control" 
                            accept="image/*" 
                            onChange={handleFileChange} 
                            required 
                        />
                    </div>
                    <small className="text-muted">※マイナンバーカードの表面をアップロードしてください。</small>
                </div>

                <div className="button-group">
                    <button type="submit" className="btn-submit">提出</button>
                    <button type="button" className="btn-draft" onClick={handleSaveDraft}>一時保存</button>
                    {((id && isDraft) || localStorage.getItem(DRAFT_KEY)) && <button type="button" className="btn-delete-draft" onClick={handleDeleteDraft} disabled={loading}>下書削除</button>}
                    <button type="button" className="btn-back" onClick={handleBack}>{onBack && !isFirstForm ? '前へ' : '戻る'}</button>
                    {isMultiForm && onNext && <button type="button" className="btn-nav" onClick={onNext}>{isLastForm ? '完了' : '次へ'}</button>}
                </div>
            </form>
        </div>
    );
};

export default MyNumberForm;